import script from "./JpAgreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./JpAgreement.vue?vue&type=script&setup=true&lang=ts"

import "./JpAgreement.vue?vue&type=style&index=0&id=7849c88e&lang=css&scoped=true"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7849c88e"]])

export default __exports__